export default __webpack_public_path__ + "static/media/slide1.7141c160.jpg";